import { render, staticRenderFns } from "./AuthAppBrandingPreview.vue?vue&type=template&id=5262b588&scoped=true"
import script from "./AuthAppBrandingPreview.vue?vue&type=script&lang=js"
export * from "./AuthAppBrandingPreview.vue?vue&type=script&lang=js"
import style0 from "./AuthAppBrandingPreview.vue?vue&type=style&index=0&id=5262b588&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262b588",
  null
  
)

export default component.exports